import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { throwError } from 'rxjs';

@Injectable()
export class GetUseritselfService {
    headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
  ) {
    this.headers = this.headers.set('Access-Control-Allow-Origin', '*');
  }

  getUseritself() {

    let user = this.msalService.instance.getActiveAccount();

    if (!user) {
      const accounts = this.msalService.instance.getAllAccounts();
      if (accounts.length) {
        user = accounts[0];
        this.msalService.instance.setActiveAccount(user);
      }
    }

    if (!user || !user.idTokenClaims) {
      console.error('[ERROR] get-useritself.service.ts > getUseritself()| No active account found.');
      return throwError(() => new Error('No active account available.'));
    }

    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    this.headers = this.headers.set('LoginUserId', loginUserId);

    return this.httpClient.get(`${apiConfig.uri}/me`, {headers: this.headers});
  }
}
